import React from "react";
import {observer} from "mobx-react";
import {IDropDownItemViewModel} from "./models/item-model/drop-down-item-view-model.interface";
import {IDropDownListViewModel} from "./models/list-model/drop-down-list-view-model.interface";
import {DropDownListComponent} from "./components/list/drop-down-list.component";
import {DropDownInputComponent} from "./components/input/drop-down-input.component";
import {CustomDropDownComponent} from "./custom-drop-down.component";
import {IDropDownController} from "./drop-down-controller.interface";
import {IFormField} from "../../models/forms/form-field.interface";


interface DropDownComponentProps<TItem extends IDropDownItemViewModel> {
    field: IFormField;
    listViewModel: IDropDownListViewModel<TItem>;
    icon?: React.ReactElement;
    renderEmptyListMessage?: () => React.ReactElement | string;
}

function DropDownComponentImplementation<TItem extends IDropDownItemViewModel>(props: DropDownComponentProps<TItem>) {
    let inputElementRef: HTMLInputElement | null = null;

    const captureInputElementRef = (element: HTMLInputElement) => {
        inputElementRef = element;
    }

    const setInputElementFocus = () => {
        if(inputElementRef) {
            inputElementRef.focus();
        }
    }

    const onDropDownOpen = () => {
        props.listViewModel.onDropDownOpen();
        setInputElementFocus();
    }

    const onDropDownClosed = () => {
        props.listViewModel.onDropDownClose();
    }

    const renderInput = (controller: IDropDownController) => {
        props.listViewModel.setDropDownController(controller);
        return (
            <DropDownInputComponent captureInputRef={captureInputElementRef}
                                    listViewModel={props.listViewModel}/>
        )
    }


    const renderList = (controller: IDropDownController) => {
        props.listViewModel.setDropDownController(controller);

        const DropDownList = DropDownListComponent<TItem>;
        return (
            <DropDownList listViewModel={props.listViewModel}
                          dropDownController={controller}
                          renderEmptyListMessage={props.renderEmptyListMessage}/>
        )
    }

    return (
        <CustomDropDownComponent label={props.field.fieldName}
                                 errorMessage={props.field.error}
                                 renderInput={renderInput}
                                 renderList={renderList}
                                 onOpen={onDropDownOpen}
                                 onClose={onDropDownClosed}
                                 icon={props.icon}/>
    );


}
export const DropDownComponent = observer(DropDownComponentImplementation);
